import Component from './serial_code_dialog.vue'
export default Component
